import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';

import VisitorProfileComponent from './VisitorProfileComponent';

import { getDoors } from '../AccessPoint/actionCreators';
import { getBuildingsForFilter } from '../Building/actionCreators';
import { showRenderPropsModal } from '../Modal/actions';
import { getPmcDoors } from '../PMC/actionCreators';
import { getVisitorInfoById, logVisitorEntry } from './actionCreators';

class VisitorProfileContainer extends Component {
  async componentDidMount() {
    const { getBuildings, getVisitorInfoById, getBuildingDoors, getPmcDoors } =
      this.props;

    getBuildings();
    const visitor = await getVisitorInfoById();
    const buildingId = visitor?.building;
    const pmcId = visitor?.pmc;
    pmcId && getPmcDoors(pmcId);
    buildingId && getBuildingDoors(buildingId);
  }

  render() {
    const {
      visitor,
      doors,
      openManageUserModal,
      getVisitorInfoById,
      onLogEntry,
      match,
    } = this.props;
    if (isEmpty(visitor)) return null;
    const props = {
      visitor,
      doors,
      openManageUserModal,
      getVisitorInfoById,
      onLogEntry,
      match,
    };
    return <VisitorProfileComponent {...props} />;
  }
}

VisitorProfileContainer.propTypes = {
  getBuildings: PropTypes.func.isRequired,
  getPmcDoors: PropTypes.func.isRequired,
  onLogEntry: PropTypes.func.isRequired,
  getVisitorInfoById: PropTypes.func.isRequired,
  getBuildingDoors: PropTypes.func.isRequired,
  openManageUserModal: PropTypes.func.isRequired,
  visitor: PropTypes.instanceOf(Object).isRequired,
  doors: PropTypes.instanceOf(Array).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const visitorId = ownProps?.match?.params?.visitorId;
  const visitor = get(state, `visitors.${visitorId}`, {});
  const propertyDoors = get(state, 'doors', []);
  const visitorDoors = get(visitor, 'invite.doors', []);
  const doors = propertyDoors.filter((buildingDoor) =>
    visitorDoors.find((visitorDoorId) => buildingDoor.id === visitorDoorId),
  );
  return {
    visitor,
    doors,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const visitorId = ownProps?.match?.params?.visitorId;
  return {
    getBuildings: () => getBuildingsForFilter(dispatch),
    getVisitorInfoById: () => getVisitorInfoById(dispatch, visitorId),
    getPmcDoors: (pmcId) => getPmcDoors(dispatch, {}, pmcId, false, false),
    getBuildingDoors: (buildingId) =>
      getDoors(dispatch, {}, buildingId, false, false),
    onLogEntry: () => logVisitorEntry(dispatch, visitorId),
    openManageUserModal: (modalProps) =>
      showRenderPropsModal(dispatch, modalProps),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VisitorProfileContainer);
